module.exports = __webpack_public_path__ + "static/img/ad-zongheceping.322b4a7d.png";